import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserCollectionGroupQueryVariables = Types.Exact<{
  filters: Types.GetByIdFilter;
}>;


export type UserCollectionGroupQuery = { group?: { id: string, name: string, description?: string | null, createdAt: string, usersCount: number, createdBy?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null, sampleUsers: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }>, filterGroup?: { operator: Types.FilterOperatorEnum, filters: Array<{ operator: Types.FilterOperatorEnum, value?: string | null, typeCast?: Types.TypeCastEnum | null, property?: { type: Types.FilterPropertyTypeEnum, value: string } | null, filters: Array<{ operator: Types.FilterOperatorEnum, value: string, typeCast?: Types.TypeCastEnum | null, property: { type: Types.FilterPropertyTypeEnum, value: string } }> }> } | null } | {} | null };


export const UserCollectionGroupDocument = /*#__PURE__*/ gql`
    query userCollectionGroup($filters: GetByIdFilter!) {
  group(filters: $filters) {
    ... on UserCollectionGroupType {
      id
      name
      description
      createdAt
      usersCount
      createdBy {
        ...User
      }
      sampleUsers {
        ...User
      }
      filterGroup {
        operator
        filters {
          operator
          property {
            type
            value
          }
          value
          typeCast
          filters {
            operator
            property {
              type
              value
            }
            value
            typeCast
          }
        }
      }
    }
  }
}
    ${UserFragmentDoc}`;

export function useUserCollectionGroupQuery(options: Omit<Urql.UseQueryArgs<UserCollectionGroupQueryVariables>, 'query'>) {
  return Urql.useQuery<UserCollectionGroupQuery, UserCollectionGroupQueryVariables>({ query: UserCollectionGroupDocument, ...options });
};